/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCompanyRoleSettings200ResponsePermissionsInner
 */
export interface GetCompanyRoleSettings200ResponsePermissionsInner {
    /**
     * `許可コード`
     * @type {string}
     * @memberof GetCompanyRoleSettings200ResponsePermissionsInner
     */
    permissionCode: string;
    /**
     * `許可名`
     * @type {string}
     * @memberof GetCompanyRoleSettings200ResponsePermissionsInner
     */
    permissionName: string;
    /**
     * `CREATE権限 true:有り  false:無し`
     * @type {boolean}
     * @memberof GetCompanyRoleSettings200ResponsePermissionsInner
     */
    create: boolean;
    /**
     * `READ権限 true:有り  false:無し`
     * @type {boolean}
     * @memberof GetCompanyRoleSettings200ResponsePermissionsInner
     */
    read: boolean;
    /**
     * `UPDATE権限 true:有り  false:無し`
     * @type {boolean}
     * @memberof GetCompanyRoleSettings200ResponsePermissionsInner
     */
    update: boolean;
    /**
     * `DELETE権限 true:有り  false:無し`
     * @type {boolean}
     * @memberof GetCompanyRoleSettings200ResponsePermissionsInner
     */
    _delete: boolean;
}

/**
 * Check if a given object implements the GetCompanyRoleSettings200ResponsePermissionsInner interface.
 */
export function instanceOfGetCompanyRoleSettings200ResponsePermissionsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "permissionCode" in value;
    isInstance = isInstance && "permissionName" in value;
    isInstance = isInstance && "create" in value;
    isInstance = isInstance && "read" in value;
    isInstance = isInstance && "update" in value;
    isInstance = isInstance && "_delete" in value;

    return isInstance;
}

export function GetCompanyRoleSettings200ResponsePermissionsInnerFromJSON(json: any): GetCompanyRoleSettings200ResponsePermissionsInner {
    return GetCompanyRoleSettings200ResponsePermissionsInnerFromJSONTyped(json, false);
}

export function GetCompanyRoleSettings200ResponsePermissionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompanyRoleSettings200ResponsePermissionsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'permissionCode': json['permission_code'],
        'permissionName': json['permission_name'],
        'create': json['create'],
        'read': json['read'],
        'update': json['update'],
        '_delete': json['delete'],
    };
}

export function GetCompanyRoleSettings200ResponsePermissionsInnerToJSON(value?: GetCompanyRoleSettings200ResponsePermissionsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'permission_code': value.permissionCode,
        'permission_name': value.permissionName,
        'create': value.create,
        'read': value.read,
        'update': value.update,
        'delete': value._delete,
    };
}

